export default "__VITE_ASSET__wlFBZxB7__"